import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import Box from "@mui/material/Box";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GET_DIPLOMAS, DELETE_DIPLOMA } from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import DownloadButton from "components/DownloadButton";
import DiplomaTemplate from "containers/Templates/Diploma";
import { getFileName } from "services/Utils";
import GroupTitle from "components/GroupTitle";
import { EnhancedTableFilterValue } from "@vocollege/components/dist/EnhancedTable";
import { GeneralObject } from "@vocollege/app/dist/global";

const Diplomas: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();
  const [educators, setEducators] = useState<EnhancedTableFilterValue[]>([]);

  const editItem = (id = "skapa") => {
    navigate(`/diplom/${id}`);
  };

  const handleDataChange = (data: any) => {
    if (data?.allGroups && data.allGroups.length > 0) {
      setEducators([
        { label: I18n.get.actions.showAll, value: "all" },
        { label: I18n.get.misc.noEducator, value: "none" },
        ...data.allGroups.map((v: GeneralObject) => ({
          label: v.title,
          value: v.id,
        })),
      ]);
    }
  };

  const getFilters = () => {
    return [
      {
        name: "educator",
        label: I18n.get.group.categories.educator,
        default: ["all"],
        multiple: true,
        values: educators,
      },
    ];
  };

  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_diplomas", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_diplomas", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any, index: number) => {
    return (
      <>
        <DownloadButton
          className={clsx(classesContentList.actionButton, {
            "vo-cert-download-from-list": index === 0,
          })}
          document={<DiplomaTemplate item={row} />}
          fileName={`${getFileName([
            row && row.firstname,
            row && row.lastname,
          ])}.pdf`}
        />
      </>
    );
  };

  // Effects.

  return (
    <>
      <Layout>
        <EnhancedTable
          enableSearch
          className="vo-global__top-bottom-space"
          title={I18n.get.diploma.labels.diplomas}
          operations={{
            category: "certDiplomas",
            get: GET_DIPLOMAS,
            delete: DELETE_DIPLOMA,
          }}
          labels={{
            deleted: I18n.get.diploma.messages.diplomaDeleted,
          }}
          columns={[
            { title: "ID", field: "id", width: 90 },
            {
              title: I18n.get.diploma.labels.diplomaType,
              field: "diploma_type",
            },
            { title: I18n.get.user.labels.firstname, field: "firstname" },
            { title: I18n.get.user.labels.lastname, field: "lastname" },
            { title: I18n.get.form.labels.date, field: "date" },
            {
              title: I18n.get.group.categories.educator,
              field: "educator",
              width: 200,
              render: (data) => <GroupTitle item={data.educator} />,
            },
            {
              title: I18n.get.misc.created_at,
              field: "created_at",
              width: 200,
            },
            {
              title: I18n.get.misc.updated_at,
              field: "updated_at",
              width: 200,
            },
          ]}
          addItem={
            VoAuth.ability.can("create_own_diplomas", "Cert")
              ? editItem
              : undefined
          }
          editItem={editItem}
          orderBy="UPDATED_AT"
          order="DESC"
          actionButtons={getActionButtons()}
          renderActionButtons={getCustomActionButtons}
          filters={getFilters()}
          onDataChange={handleDataChange}
        />
      </Layout>
    </>
  );
};

export default Diplomas;
